
export default {
  getReactions(state) {

    if (!state.widget ||
      !state.widget.reactions ||
      !state.visitor ||
      !state.messages ||
      !state.session
    )
      return null

    let time_on = state.session && state.session.time_on ? state.session.time_on : 0

    let when = state.widget.onlineAgentsList ? 'online' : 'offline'
    let list = Object.keys(state.widget.reactions).map((key)=>{
        return {
          key,
          ...state.widget.reactions[key]
        }
      })
      .filter(item=>item.enabled && item.when == when)
      .filter((item)=>{

        return !((state.visitor.reactions_done &&
          (typeof state.visitor.reactions_done == 'number' ||
          state.visitor.reactions_done[item.key]) &&
          item.then.per == 'visitor') ||
          (state.session.reactions_done &&
            (typeof state.session.reactions_done == 'number' ||
            state.session.reactions_done[item.key]) &&
            item.then.per == 'session') ||
          (state.reactionsDone &&
            state.reactionsDone[item.key])) &&
            item.view_state == state.session.view_state

      })

    return list

  }
}
